import { render, staticRenderFns } from "./data-china-beef-imports.vue?vue&type=template&id=4e932056&scoped=true"
import script from "./data-china-beef-imports.vue?vue&type=script&lang=js"
export * from "./data-china-beef-imports.vue?vue&type=script&lang=js"
import style0 from "./data-china-beef-imports.vue?vue&type=style&index=0&id=4e932056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e932056",
  null
  
)

export default component.exports